/* eslint-disable */
import {makeMomentDate} from "./makeMomentDate"

// Database constants
const ASSIGNEE__ASSIGNEE_ID = "assigneeId"
const ASSIGNEE__COMPANY_NAME = "companyName"
const ASSIGNEE__EMPLOYEE_ID = "employeeId"
const ASSIGNEE__FIRST_NAME = "firstName"
const ASSIGNEE__LAST_NAME = "lastName"
const ASSIGNEE__WORK_RECORD_ID = "workRecordId"
const ASSIGNEE_DATA = "AssigneeData"
const ASSIGNMENT_END_DATE = "AssignmentEndDate"
const ASSIGNMENT_START_DATE = "AssignmentStartDate"
const CALCULATION_TYPE = "CalculationType"
const COUNTRY = "Country"
const COUNTRY__CODE = "value"
const COUNTRY__NAME = "label"
const FILING_STATUS = "FilingStatus"
const HOME = "Home"
const HOST = "Host"
const INCOME = "Income"
const INPUT_DATA = "InputData"
const REGION = "Region"
const REGION_FILING_STATUS = "RegionFilingStatus"
const SOCIAL = "Social"
const TAX_CALCULATIONS = "TaxCalculations"

export const mapInputToTemplate = (input, template, resources) => {
  // Prepare the individual data objects
  const assigneeData = input[ASSIGNEE_DATA]
  const inputData = input[INPUT_DATA]

  return {
    ...makeAssignee(assigneeData),
    ...makeTrip(inputData[TAX_CALCULATIONS], resources.jurisdictions),
    demographics: makeDemographics(
      inputData[TAX_CALCULATIONS],
      template,
      resources
    ),
    endDate: makeMomentDate(
      inputData[ASSIGNMENT_END_DATE],
      template.dateFormat
    ),
    startDate: makeMomentDate(
      inputData[ASSIGNMENT_START_DATE],
      template.dateFormat
    ),
  }
}

const makeAssignee = (assigneeData) => {
  // Initialize an empty object
  const results = {}

  // Iterate over each item in the assignee data array
  assigneeData.forEach((item) => {
    switch (item.name) {
      case ASSIGNEE__ASSIGNEE_ID:
        return (results.assigneeId = item.value)
      case ASSIGNEE__COMPANY_NAME:
        return (results.organization = item.value)
      case ASSIGNEE__EMPLOYEE_ID:
        return (results.employeeId = item.value)
      case ASSIGNEE__FIRST_NAME:
        return (results.firstName = item.value)
      case ASSIGNEE__LAST_NAME:
        return (results.lastName = item.value)
      case ASSIGNEE__WORK_RECORD_ID:
        return (results.workRecordId = item.value)
    }
  })

  return results
}

const makeTrip = (inputData, jurisdictions) => {
  // Initialize an empty object for the locations
  const results = {}

  // Iterate over the Calculations array
  inputData.forEach((calculation) => {
    // If this is a Home Calculation
    if (calculation[CALCULATION_TYPE] === HOME) {
      // Find the Jurisdiction object and return the label
      const location = makeTripLocation(calculation, jurisdictions)
      results.startLocation = location.label
    }
    // If this is a Host Calculation
    if (calculation[CALCULATION_TYPE] === HOST) {
      // Find the Jurisdiction object and return the label
      const location = makeTripLocation(calculation, jurisdictions)
      results.endLocation = location.label
    }
  })

  return results
}

const makeTripLocation = (calculation, jurisdictions) => {
  // Prepare the Region or Country code
  const location = calculation[INCOME][REGION] || calculation[INCOME][COUNTRY]
  // Find the code in the Jurisdictions array and return the object
  return jurisdictions.find((jurisdiction) => jurisdiction.value === location)
}

const makeDemographics = (demographics, template, resources) => {
  // Initialize empty arrays for the columns and rows
  const columns = []
  const rows = []

  // Iterate over each calculation object in the demographics array
  demographics.forEach((calculation, calculationIndex) => {
    // Initialize data objects for the table cell values
    const incomeData = {
      name: `${calculation[CALCULATION_TYPE]} ${INCOME}`,
      cells: {},
    }
    const socialData = {
      name: `${calculation[CALCULATION_TYPE]} ${SOCIAL}`,
      cells: {},
    }

    // For each calculation, iterate over the Demographics columns in the template
    template.demographics.forEach((column) => {
      const {code, name} = column
      // Get the Income and Social values for this cell (only one will have a value)
      const incomeValue = calculation[INCOME][code]
      const socialValue = calculation[SOCIAL][code]

      // If this is an Income cell
      if (incomeValue) {
        // Get the label for this value and add it to the Income data object
        incomeData.cells[code] = makeDemographicsLabels(
          incomeValue,
          code,
          resources
        )
      }

      // If this is a Social cell
      if (socialValue) {
        // Get the label for this value and add it to the Social data object
        socialData.cells[code] = makeDemographicsLabels(
          socialValue,
          code,
          resources
        )
      }

      // If this is neither an Income nor Social value, report an error
      if (!incomeValue && !socialValue) {
        console.warn(
          `[${code}] is not a supported Demographics column. Any data associated with this column will not appear on the report.`
        )
      }

      // If this is the first iteration over the template
      if (calculationIndex === 0) {
        // Add the code and name to the columns array
        columns.push({code, name})
      }
    })

    // Push the Income and Social data objects to the rows array
    rows.push(incomeData, socialData)
  })

  return {columns, rows}
}

const makeDemographicsLabels = (value, column, resources) => {
  switch (column) {
    // If this is a Country column
    case COUNTRY:
      // Find the Country data in the Resources object
      const country = resources.countries.find(
        (item) => item[COUNTRY__CODE] === value
      )

      // If this Country code does not exist in Resources, report an error
      if (!country) {
        console.warn(
          `[${value}] is not a supported country code. Any data associated with this country will not appear on the report.`
        )
        // Return the Country code
        return value
      }

      // If the Country code exists in Resources, return the Country name
      return country[COUNTRY__NAME]

    // If this is a Filing Status column
    case FILING_STATUS:
    case REGION_FILING_STATUS:
      // Return the Filing Status label from Resources
      return resources.filingStatuses[value]

    // If this is a Region column
    case REGION:
      // Find the Jurisdiction object in Resources
      const jurisdiction = resources.jurisdictions.find(
        (item) => item.value === value
      )
      // Return the Jurisdiction label
      return jurisdiction.label

    default:
      return value
  }

  return value
}
